import { Fl44CabinetCustomerContracts } from '@/services/backend/cabinet/customer/contracts';
import { Fl44CabinetCustomerBlockRequests } from '@/services/backend/cabinet/customer/block-requests';

export const customer = {
    contracts: new Fl44CabinetCustomerContracts(),
    blockRequests: new Fl44CabinetCustomerBlockRequests()
};
